import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, MenuSection, Pane, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import TableComponent from "../../components/TableComponent";
import NavComponent from "../../components/NavComponent";
import CollectionDetail from "./CollectionDetail";
import { CollectionsFilters } from "../../components/CollectionsFilters";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { createStripesSource } from "../../utils/createStripesSource";
import { useCollectionsFilters } from "../../hooks/useCollectionsFilters";
import { useCollectionsData } from "../../hooks/useCollectionsData";
import { useCollectionsTable } from "../../hooks/useCollectionsTable";
import { useCollectionsActions } from "../../hooks/useCollectionsActions";
import { usePermissions } from "../../hooks/usePermissions";
import { usePageSize } from "../../hooks/usePageSize";
import { RoleGroups } from "../../types/RoleEnum";
import { CurrentUserLoadErrorBanner } from "../../components/CurrentUserLoadErrorBanner";
export var CollectionsList = function () {
    var history = useHistory();
    var formatMessage = useIntl().formatMessage;
    var _a = useState(true), filterPaneIsVisible = _a[0], setFilterPaneIsVisible = _a[1];
    var filtersHook = useCollectionsFilters();
    var _b = usePageSize(), pageSize = _b.pageSize, createPageSizeHandler = _b.createPageSizeHandler;
    var dataHook = useCollectionsData(filtersHook.filters, pageSize, filtersHook.filtersReady);
    var actionsHook = useCollectionsActions();
    var tableColumns = useCollectionsTable(actionsHook.handleRowClick).tableColumns;
    var hasAnyRole = usePermissions().hasAnyRole;
    var canEditCollection = hasAnyRole(RoleGroups.COLLECTION_EDITOR_ROLES);
    var toggleFilterPane = function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); };
    var handlePageSizeChange = createPageSizeHandler(dataHook.fetchMoreData);
    var handleApplyFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleApplyFilters();
    };
    var handleClearFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleClearFilters();
    };
    var source = createStripesSource({
        ky: null,
        data: dataHook.collectionsData,
        totalRecords: dataHook.totalRecords,
        isLoading: dataHook.isLoading || dataHook.isWaitingForFilters,
        isError: dataHook.isError,
        isLoaded: dataHook.isFetched,
        fetchMore: function () {
            return dataHook.fetchMoreData(dataHook.pageOffset + dataHook.pageSize);
        },
    });
    return (React.createElement(RecekPaneSet, null,
        filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-agency.pane.title.navigation",
            }) },
            React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                React.createElement(NavComponent, null),
                React.createElement(Button, { buttonStyle: "none", id: "clickable-reset-all", disabled: !filtersHook.isAnyFilterActive(), marginBottom0: true, onClick: handleClearFilters },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.resetAll" })),
                React.createElement(CollectionsFilters, { temporaryTypeFilter: filtersHook.temporaryTypeFilter, temporaryNameFilter: filtersHook.temporaryNameFilter, temporaryPublisherFilter: filtersHook.temporaryPublisherFilter, temporaryIssnFilter: filtersHook.temporaryIssnFilter, publisherSearchQuery: filtersHook.publisherSearchQuery, selectedPublisherData: filtersHook.selectedPublisherData, selectedPublisherLoading: filtersHook.selectedPublisherLoading, onTypeFilterChange: filtersHook.setTemporaryTypeFilter, onNameFilterChange: filtersHook.setTemporaryNameFilter, onPublisherFilterChange: filtersHook.handlePublisherSelection, onIssnFilterChange: filtersHook.setTemporaryIssnFilter, onPublisherSearchInput: filtersHook.handlePublisherSearchInput, onApplyFilters: handleApplyFilters })))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-agency.collections.table.title",
            }), paneSub: formatMessage({ id: "ui-br-agency.table.subtitle.records-found" }, { count: dataHook.totalRecords }), actionMenu: canEditCollection
                ? function (_a) {
                    var onToggle = _a.onToggle;
                    return (React.createElement(MenuSection, { label: "Akce", id: "actions-menu" },
                        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                onToggle();
                                history.push("/bragency/collections/create");
                            } },
                            React.createElement(FormattedMessage, { id: "ui-br-agency.button.create" }))));
                }
                : undefined },
            React.createElement(CurrentUserLoadErrorBanner, { show: filtersHook.currentUserLoadFailed }),
            React.createElement(TableComponent, { data: dataHook.collectionsData, columns: tableColumns, pageSize: pageSize, onPageSizeChange: handlePageSizeChange, totalCount: dataHook.totalRecords, pagingOffset: dataHook.pageOffset, onNeedMoreData: function (offset) { return dataHook.fetchMoreData(offset); }, searchTerm: "", filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane, source: source })),
        actionsHook.selectedCollection && (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: formatMessage({
                id: "ui-br-agency.collections.detail.pane.title",
            }), onClose: actionsHook.handleCloseDetail, dismissible: true, actionMenu: canEditCollection
                ? function () { return (React.createElement(MenuSection, { label: "Akce", id: "actions-menu" },
                    React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                            var _a;
                            return history.push("/bragency/collections/edit/".concat((_a = actionsHook.selectedCollection) === null || _a === void 0 ? void 0 : _a.id));
                        }, fullWidth: true },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.button.edit" })))); }
                : undefined },
            React.createElement(CollectionDetail, { collection: actionsHook.selectedCollection })))));
};
